const messages = {
  pt: {
    translations: {
      common: {
        yes: "Sim",
        no: "NÃ£o",
        tags: "Etiquetas",
        noTags: "Sem Etiquetas",
      },
      signup: {
        title: "Cadastre-se",
        launcher: {
          title: "Escolher canal",
          description:
            "Selecione o canal que deseja conectar para esta empresa. O fluxo por QR continua igual e os canais Meta usam a configuracao atual.",
          whatsappQrTitle: "WhatsApp QR",
          whatsappQrDescription:
            "Mantem o fluxo atual com QR e sessao do celular usando Baileys. Nao altera nada do que hoje ja funciona.",
          whatsappQrTag: "Sessao QR",
          whatsappApiTitle: "WhatsApp API",
          whatsappApiDescription:
            "Cria uma conexao oficial da Meta para automacoes, templates, webhooks e operacao por Cloud API.",
          whatsappApiTag: "Oficial",
          whatsappCoexistenceTitle: "YCloud coexistente",
          whatsappCoexistenceDescription:
            "Usa o mesmo canal oficial quando seu numero ja foi habilitado em coexistencia dentro da Meta, sem substituir o QR.",
          whatsappCoexistenceTag: "YCloud",
          facebookTitle: "Facebook",
          facebookDescription:
            "Conecta paginas e mensagens do Facebook com o login atual da Meta para esta empresa.",
          instagramTitle: "Instagram",
          instagramDescription:
            "Conecta Instagram Direct e comentarios com o login atual da Meta para esta empresa.",
          metaLoginTag: "Meta Login",
        },
        toasts: {
          success: "UsuÃ¡rio criado com sucesso! FaÃ§a seu login!!!.",
          disabled:
            "Cadastro de usuÃ¡rios estÃ¡ desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuÃ¡rio. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da OrganizaÃ§Ã£o",
          phone: "Whatsapp (DDD + NÃšMERO)",
        },
        buttons: {
          submit: "Cadastrar",
          login: "JÃ¡ tem uma conta? Entre!",
        },
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rÃ¡pidas",
        phonecopied: "Telefone copiado para Ã¡rea de transferÃªncia!",
        noPhone: "Nenhum telefone disponÃ­vel para copiar",
        copyError: "Erro ao copiar telefone",
      },
      login: {
        title: "Login",
        welcome: "Bem-vindo de volta",
        loginInstruction: "Entre com seus dados para acessar sua conta",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Entrar",
          register: "NÃ£o tem um conta? Cadastre-se!",
        },
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuario",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "DisponÃ­vel atÃ©",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliaÃ§Ã£o",
          callsWithoutRating: "Atendimentos sem avaliaÃ§Ã£o",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Ãndice de avaliaÃ§Ã£o",
          score: "PontuaÃ§Ã£o",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
      },
      reports: {
        title: "RelatÃ³rio de Pesquisas Realizadas",

        operator: "Operador",
        period: "PerÃ­odo",
        until: "AtÃ©",
        date: "Data",
        reportTitle: "RelatÃ³rios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "DuracÃ£o dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Lima",
          msgToast: "Gerando relatÃ³rio compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatÃ³rio",
          back: "Voltar",
          groupServiceReport: "RelatÃ³rio de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Ãšltima AtualizaÃ§Ã£o",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "RelatÃ³rio de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatÃ³rio compactado, por favor aguarde.",
          title: "RelatÃ³rio de DuraÃ§Ã£o do Atendimento",
          startService: "InÃ­cio do atendimento",
          lastUpdated: "Ãšltima atualizaÃ§Ã£o",
          lastAgent: "Ãšltimo atendente",
          durationFinished: "DuraÃ§Ã£o apÃ³s finalizado",
        },
        ticketDuration: {
          title: "RelatÃ³rio de DuraÃ§Ã£o dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "DuraÃ§Ã£o dos finalizados",
          durationAfterFinished: "DuraÃ§Ã£o apÃ³s finalizado",
          actions: "AÃ§Ãµes",
        },
        ticketReports: {
          msgToast: "Gerando relatÃ³rio compactado, por favor aguarde.",
          title: "RelatÃ³rio de Atendimento",
        },
        exportExcel: {
          title: "RelatÃ³rios de Atendimentos",
          startDate: "Data inicial",
          endDate: "Data final",
          notInformed: "NÃ£o informado",
          columns: {
            id: "ID",
            connection: "ConexÃ£o",
            connectionNumber: "NÃºmero ConexÃ£o",
            contact: "Contato",
            tags: "Tags",
            kanban: "Kanban",
            user: "UsuÃ¡rio",
            queue: "Fila",
            status: "Status",
            lastMessage: "Ãšltima Mensagem",
            lastMessageDate: "Data Ãšlt. Mensagem",
            lastMessageTime: "Hora Ãšlt. Mensagem",
            openDate: "Data Abertura",
            openTime: "Hora Abertura",
            closeDate: "Data Fechamento",
            closeTime: "Hora Fechamento",
            supportTime: "Tempo de Atendimento",
            nps: "NPS",
            valorVenda: "Valor da Venda",
            motivoNaoVenda: "Motivo da NÃ£o Venda",
            finalizadoComVenda: "Finalizado com Venda",
          },
        },
        pdf: {
          title: "RelaÃ§Ã£o de Atendimentos Realizados",
          exportTitle: "RelaÃ§Ã£o de Atendimentos em Grupos Realizados",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },
      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importaÃ§Ã£o",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
      },
      connections: {
        title: "ConexÃµes",
        waitConnection: "Aguarde... Suas conexÃµes serÃ£o reiniciadas!",
        newConnection: "Nova ConexÃ£o",
        restartConnections: "Reiniciar ConexÃµes",
        callSupport: "Chamar Suporte",
        newConnection: "Nova ConexÃ£o",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " ConexÃµes conectadas ",
        disconnectedConnections: "ConexÃµes desconectadas ",
        totalConnections: " Total de ConexÃµes",
        total: "Total",
        connections: "ConexÃµes de:",

        toasts: {
          deleted: "ConexÃ£o excluÃ­da com sucesso!",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se vocÃª confirmar todos os tickets importados serÃ£o fechados",
          deleteTitle: "Deletar",
          deleteMessage: "VocÃª tem certeza? Essa aÃ§Ã£o nÃ£o pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? VocÃª precisarÃ¡ ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar ConexÃ£o",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importaÃ§Ã£o",
          importing: "Importando Mensagens do WhatsApp",
          newQr: "Novo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessÃ£o do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado Ã  internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botÃ£o 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessÃ£o",
          },
          connected: {
            title: "ConexÃ£o estabelecida!",
          },
          timeout: {
            title: "A conexÃ£o com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado Ã  internet e o WhatsApp esteja aberto, ou clique no botÃ£o 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          channel: "Canal",
          color: "Cor",
          id: "ID",
          name: "Nome",
          status: "Status",
          lastUpdate: "Ãšltima atualizaÃ§Ã£o",
          default: "PadrÃ£o",
          actions: "AÃ§Ãµes",
          session: "SessÃ£o",
          number: "NÃºmero do Whatsapp",
          color: "Cor",
          receiveComments: "Receber ComentÃ¡rios",
        },
        receiveComments: {
          enabled: "Recebimento de comentÃ¡rios habilitado",
          disabled: "Recebimento de comentÃ¡rios desabilitado",
          tooltip: {
            enabled: "ComentÃ¡rios estÃ£o sendo recebidos. Clique para desabilitar.",
            disabled: "ComentÃ¡rios nÃ£o estÃ£o sendo recebidos. Clique para habilitar.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato jÃ¡ estÃ¡ em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato jÃ¡ estÃ¡ aguardando atendimento. Veja na aba Aguardando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
          clientClosed: "Cliente fechou o ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar ConexÃ£o",
          edit: "Editar ConexÃ£o",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "IntegraÃ§Ãµes",
          schedules: "HorÃ¡rio de expediente",
        },
        form: {
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessages: "Data de inicio da importaÃ§Ã£o",
          importRecentMessages: "Data de termino da importaÃ§Ã£o",
          importOldMessagesGroups: "Importar mensagens de grupo",
          closedTicketsPostImported: "Encerrar tickets apÃ³s importaÃ§Ã£o",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que nÃ£o possuem fila serem redirecionados",
          default: "PadrÃ£o",
          group: "Permitir grupos",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÃ‡ÃƒO: Ao salvar, sua conexÃ£o serÃ¡ encerrada, serÃ¡ necessÃ¡rio ler novamente o QR Code para importar as mensagens",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativaÃ§Ã£o do fluxo",
          expiresTicket: "Encerrar chats abertos apÃ³s x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliaÃ§Ã£o apÃ³s x minutos",
          maxUseBotQueuesNPS:
            "Quantidade mÃ¡xima de vezes que a avaliaÃ§ao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudaÃ§Ã£o",
          complationMessage: "Mensagem de conclusÃ£o",
          lgpdLinkPrivacy: "Link para polÃ­tica de privacidade",
          lgpdMessage: "Mensagem de saudaÃ§ao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmaÃ§Ã£o do contato",
          ratingMessage: "Mensagem de avaliaÃ§ao - Escala deve ser de 0 a 10",
          token: "Token para integraÃ§Ã£o externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime:
            "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando Ãºltima mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          prompt: "Prompt",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de fÃ©rias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens",
          isOficial: "Oficial",
          officialSetupTitle: "WhatsApp Oficial",
          officialBadge: "Meta Cloud API",
          officialSetupDescription:
            "Use este canal para conectar nÃƒÂºmeros da API oficial da Meta, incluindo nÃƒÂºmeros em coexistÃƒÂªncia. O QR atual continua separado e nÃƒÂ£o ÃƒÂ© afetado por esta configuraÃƒÂ§ÃƒÂ£o.",
          officialCloudTitle: "Cloud API",
          officialCloudDescription:
            "Preencha os identificadores e o token do nÃƒÂºmero oficial para ativar envio, recebimento e automaÃƒÂ§ÃƒÂµes pelo canal da Meta.",
          officialCoexistenceTitle: "CoexistÃƒÂªncia",
          officialCoexistenceDescription:
            "Se o nÃƒÂºmero jÃƒÂ¡ estiver habilitado em coexistÃƒÂªncia na Meta, ele pode operar aqui pelo canal oficial sem substituir sua conexÃƒÂ£o por QR.",
          officialWebhook: "Webhook oficial",
          officialSetupHelper:
            "Os dados abaixo pertencem ao nÃƒÂºmero oficial configurado na Meta. Este fluxo mantÃƒÂ©m o QR/Baileys intacto e usa o canal oficial apenas nesta conexÃƒÂ£o.",
          phone_number_id: "ID NÃºmero de telefone",
          officialSetupDescription:
            "Use este canal para conectar n\u00FAmeros da API oficial da Meta, incluindo n\u00FAmeros em coexist\u00EAncia. O QR atual continua separado e n\u00E3o \u00E9 afetado por esta configura\u00E7\u00E3o.",
          officialCloudDescription:
            "Preencha os identificadores e o token do n\u00FAmero oficial para ativar envio, recebimento e automatiza\u00E7\u00F5es pelo canal da Meta.",
          officialCoexistenceTitle: "Coexist\u00EAncia",
          officialCoexistenceDescription:
            "Se o n\u00FAmero j\u00E1 estiver habilitado em coexist\u00EAncia na Meta, ele pode operar aqui pelo canal oficial sem substituir sua conex\u00E3o por QR.",
          officialSetupHelper:
            "Os dados abaixo pertencem ao n\u00FAmero oficial configurado na Meta. Este fluxo mant\u00E9m o QR/Baileys intacto e usa o canal oficial apenas nesta conex\u00E3o.",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do Business Manager",
          phone_number: "NÃºmero de telefone",
          ycloudApiKey: "YCloud API Key",
          ycloudApiKey: "YCloud API Key",
          ycloudWebhookSecret: "YCloud Webhook Secret (whsec_...)",
          ycloudWebhookUrl: "YCloud Webhook URL",
          triggerIntegrationOnClose: "Disparar IntegraÃ§Ã£o ao Encerrar Ticket",
          enableIntegration: "Habilitar IntegraÃ§Ã£o",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos",
        },
        success: "ConexÃ£o salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porÃ©m nÃ£o foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "Ã‰ obrigado informar um tempo para avaliaÃ§Ã£o quando se utiliza o NPS.",
        errorRatingMessage:
          "Ã‰ obrigado informar uma mensagem de avaliaÃ§Ã£o quando se utiliza o NPS.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessÃ£o",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluÃ­do com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: " Fluxos de Conversa",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serÃ£o perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
        },
        loading: "Carregando...",
        loadMore: "Carregar Mais",
        table: {
          name: "Nome",
          whatsapp: "ConexÃ£o",
          email: "Email",
          actions: "AÃ§Ãµes",
          lastMessage: "Ãšltima Mensagem",
          wallet: "Carteira",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrÃ£o",
          importToExcel: "Importar / Exportar do Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "MÃ¡ximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "MÃ¡ximo de mensagens no HistÃ³rico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "RegiÃ£o de Voz",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        noPermission:
          "Esta empresa nao possui permissao para acessar esta pagina. Estamos te redirecionando.",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "MÃ¡ximo Tokens Resposta",
          actions: "AÃ§Ãµes",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "VocÃª tem certeza? Essa aÃ§Ã£o nÃ£o pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "InformaÃ§Ãµes adicionais",
          name: "Nome",
          number: "NÃºmero do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "ConexÃ£o Origem: ",
          assignWallet: "Carteira de Cliente",
        },
        buttons: {
          addExtraInfo: "Adicionar informaÃ§Ã£o",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado Ã  sua carteira com sucesso!",
        walletError: "UsuÃ¡rio nÃ£o possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro",
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por UsuÃ¡rio",
        allUsers: "Todos os usuÃ¡rios",
        contact: "Contato",
        user: "UsuÃ¡rio",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "AÃ§Ãµes",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar UsuÃ¡rio",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuÃ¡rio e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar ExclusÃ£o",
        confirmDeleteMessage:
          "Tem certeza que deseja remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "HorÃ¡rios de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opÃ§Ãµes de integraÃ§Ãµes serÃ£o deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "RodÃ­zio",
          timeRotate: "Tempo de RodÃ­zio",
          typeRandomMode: "Tipo de rodÃ­zio",
          greetingMessage: "Mensagem de saudaÃ§Ã£o",
          complationMessage: "Mensagem de conclusÃ£o",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "IntegraÃ§Ã£o",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          randomizeImmediate: "Randomizar Automaticamente (Imediato)",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferÃªncia",
          integration: "IntegraÃ§Ã£o",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "OpÃ§Ãµes",
          toolTipTitle: "Adicione opÃ§Ãµes para construir um chatbot",
          toolTip:
            "Se houver apenas uma opÃ§Ã£o, ela serÃ¡ escolhida automaticamente, fazendo com que o bot responda com a mensagem da opÃ§Ã£o e siga adiante",
          selectOption: "Selecione uma opÃ§Ã£o",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "IntegraÃ§Ã£o",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem Ã© obrigatÃ³ria para seguir ao prÃ³ximo nÃ­vel",
          toolTipMessageContent:
            "A mensagem Ã© obrigatÃ³ria para seguir ao prÃ³ximo nÃ­vel",
          selectUser: "Selecione um UsuÃ¡rio",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma IntegraÃ§Ã£o",
          addOptions: "Adicionar opÃ§Ãµes",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "TerÃ§a-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "SÃ¡bado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opÃ§Ã£o invÃ¡lida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
          flowBuilderEnabled: "Ativar Flow Builder junto com esta integraÃ§Ã£o",
          flowBuilderEnabledHint: "Permite usar etiquetas, kanban e palavras-chave do Flow Builder",
          allowFlowbuilder: "Permitir FlowBuilder em paralelo",
          flowId: "Fluxo",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "IntegraÃ§Ã£o testada com sucesso!",
          addSuccess: "IntegraÃ§Ã£o adicionada com sucesso.",
          editSuccess: "IntegraÃ§Ã£o editada com sucesso.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importaÃ§Ã£o das mensagens Ã© necessÃ¡rio ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuÃ¡rio",
          edit: "Editar usuÃ¡rio",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "ConexÃ£o PadrÃ£o",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrÃ£o",
          defaultTheme: "Tema PadrÃ£o",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuÃ¡rios",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showReturnQueueButton: "Mostrar botÃ£o de devolver para fila",
          showTransferTicketButton: "Mostrar botÃ£o de transferir ticket",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir aÃ§Ãµes nas conexÃµes",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver automaÃ§Ãµes",
        },
        tabs: {
          general: "Geral",
          permissions: "PermissÃµes",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "UsuÃ¡rio salvo com sucesso.",
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "UsuÃ¡rios",
          numberConections: "ConexÃµes",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          message: "Mensagem",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Tempo em minutos para redirecionar para lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensagem de saudaÃ§Ã£o da lane",
          mediaFiles: "MÃ­dia",
          rollbackLaneId: "Voltar para Lane apÃ³s retomar atendimento",
          integrationId: "Integracao FlowBuilder",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opÃ§Ã£o",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para comeÃ§ar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "â¬‡ï¸ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO â¬‡ï¸",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta aÃ§Ã£o nÃ£o pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÃŠ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃƒO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensagem oculta",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃƒO",
          open: "Abertos",
          resolverd: "Resolvidos",
          all: "Todos",
          searchOnMessages: "Marque para pesquisar tambÃ©m no conteÃºdo das mensagens (mais lento)",
          oldFirst: "Antigos primeiro",
          newFirst: "Recentes primeiro",
          unread: "NÃ£o lidos",
        },
        toasts: {
          deleted: "O atendimento que vocÃª estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
          messageHidden: "Mensagem oculta",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por ConexÃ£o",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por pÃ¡gina",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuÃ¡rios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuÃ¡rio encontrado com esse nome",
        msgTransfer: "ObservaÃ§Ãµes - mensagem interna, nÃ£o vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta aÃ§Ã£o nÃ£o pode ser revertida, confirmar?",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vÃ­deo perdida Ã s",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          exportAsText: "Exportar como texto (.txt)",
          kanbanActions: "OpÃ§Ãµes de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "ConexÃµes",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rÃ¡pidas",
          contacts: "Contatos",
          wallets: "Carteiras",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "AdministraÃ§Ã£o",
          companies: "Empresas",
          users: "UsuÃ¡rios",
          birthdayMenu: "Config. AniversÃ¡rio",
          settings: "ConfiguraÃ§Ãµes",
          files: "Lista de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          queueIntegration: "IntegraÃ§Ãµes",
          version: "VersÃ£o",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gerenciar conexÃµes",
          reports: "RelatÃ³rios",
          management: "GerÃªncia",
          callHistorical: "HistÃ³rico de Chamadas",
          automations: "AutomaÃ§Ãµes",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "OlÃ¡",
            messageEnd: "seja bem-vindo a",
            active: "Ativo atÃ©",
            goodMorning: "Oi,",
            myName: "meu nome Ã©",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token invÃ¡lido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "LocalizaÃ§Ã£o",
            contact: "Contato",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "PortuguÃªs",
        es: "EspaÃ±ol",
        en: "English",
        tr: "TÃ¼rkÃ§e",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "NÃºmero",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuÃ¡rio/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "NÃºmero",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "DocumentaÃ§Ã£o para envio de mensagens",
          methods: {
            title: "MÃ©todos de EnvÃ­o",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "InstruÃ§Ãµes",
            comments: "ObservaÃ§Ãµes Importantes",
            comments1:
              "Antes de enviar mensagens, Ã© necessÃ¡rio o cadastro do token vinculado Ã  conexÃ£o que enviarÃ¡ as mensagens. <br />Para realizar o cadastro acesse o menu 'ConexÃµes', clique no botÃ£o editar da conexÃ£o e insira o token no devido campo.",
            comments2:
              "O nÃºmero para envio nÃ£o deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "CÃ³digo do PaÃ­s",
            code: "DDD",
            number: "NÃºmero",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informaÃ§Ãµes necessÃ¡rias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informaÃ§Ãµes necessÃ¡rias para envio das mensagens de texto:",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificaÃ§Ã£o.",
        messageHidden: "Mensagem oculta",
        newMessage: "Nova mensagem de",
        recentMessages: "Mensagens",
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description:
          "Selecione um fluxo para executar neste ticket. O ticket serÃ¡ alterado para status 'chatbot' durante a execuÃ§Ã£o.",
        selectFlow: "Escolha um fluxo",
        searchPlaceholder: "Buscar fluxo por nome ou ID...",
        noResults: "Nenhum fluxo encontrado para essa busca.",
        selectedFlow: "Fluxo selecionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo ativo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com sucesso!",
        error: "Erro ao disparar fluxo",
      },
      quickMessages: {
        title: "Respostas RÃ¡pidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "ExclusÃ£o",
          deleteMessage: "Esta aÃ§Ã£o Ã© irreversÃ­vel! Deseja prosseguir?",
        },
        selectMessage: "Selecionar Resposta RÃ¡pida",
        hasMedia: "Com mÃ­dia",
        global: "Global",
        noResultsFound: "Nenhuma resposta rÃ¡pida encontrada para sua busca",
        noQuickMessages: "Nenhuma resposta rÃ¡pida disponÃ­vel",
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem RÃ¡pida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          general: "Geral",
          visao: "Permitir visÃ£o",
          tag: "Etiqueta para aplicar",
          noTag: "Sem etiqueta",
          status: "Status",
          language: "Idioma",
          category: "Categoria",
          metaID: "Meta ID",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          media: "MÃ­dia",
          actions: "AÃ§Ãµes",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "AÃ§Ãµes",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta aÃ§Ã£o nÃ£o pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluÃ­do",
        },
      },
      companies: {
        buttons: {
          add: "Nova Empresa",
        },
        toasts: {
          loadingError: "NÃ£o foi possÃ­vel carregar a lista de registros",
          success: "OperaÃ§Ã£o realizada com sucesso!",
          error: "NÃ£o foi possÃ­vel realizar a operaÃ§Ã£o. Verifique se jÃ¡ existe uma empresa com o mesmo nome ou se os campos foram preenchidos corretamente",
          deleted: "Empresa excluÃ­da com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "ExclusÃ£o de Registro",
          deleteMessage: "Deseja realmente excluir esse registro?",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "NÃºmero",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "NÃºmero",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "AÃ§Ãµes",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta aÃ§Ã£o nÃ£o pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluÃ­do",
        },
      },

      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Painel",
          tags: "Lanes",
        },
      },

      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "ConfiguraÃ§Ãµes",
        },
        settings: {
          randomInterval: "Intervalo RandÃ´mico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior apÃ³s",
          undefined: "NÃ£o definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variÃ¡vel",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "ConteÃºdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "ConexÃ£o",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "ConcluÃ­da",
          confirmation: "ConfirmaÃ§Ã£o",
          actions: "AÃ§Ãµes",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas VisualizaÃ§Ã£o",
          help: "Utilize variÃ¡veis como {nome}, {numero}, {email} ou defina variÃ¡veis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de ConfirmaÃ§Ã£o 1",
            confirmationMessage2: "Mensagem de ConfirmaÃ§Ã£o 2",
            confirmationMessage3: "Mensagem de ConfirmaÃ§Ã£o 3",
            confirmationMessage4: "Mensagem de ConfirmaÃ§Ã£o 4",
            confirmationMessage5: "Mensagem de ConfirmaÃ§Ã£o 5",
            messagePlaceholder: "ConteÃºdo da mensagem",
            whatsapp: "ConexÃ£o",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "ConfirmaÃ§Ã£o",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta aÃ§Ã£o nÃ£o pode ser revertida.",
        },
        toasts: {
          success: "OperaÃ§Ã£o realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluÃ­do",
        },
        noPermission: "Esta empresa nÃ£o tem permissÃ£o para acessar esta pÃ¡gina! Redirecionando.",
        recurrenceStopped: "RecorrÃªncia interrompida com sucesso!",
        status: {
          inactive: "Inativa",
          scheduled: "Programada",
          inProgress: "Em Andamento",
          cancelled: "Cancelada",
          finished: "Finalizada",
        },
        recurrence: {
          perMinute: "Por Minuto",
          perHour: "Por Hora",
          daily: "DiÃ¡rio",
          weekly: "Semanal",
          biweekly: "Quinzenal",
          monthly: "Mensal",
          yearly: "Anual",
        },
        filterByStatus: "Filtrar por Status",
        filterByRecurrence: "Filtrar por RecorrÃªncia",
        all: "Todos",
        recurring: "Recorrentes",
        single: "Ãšnica",
        recurringCampaign: "Campanha Recorrente",
        executions: "execuÃ§Ãµes",
        listRemoved: "Lista removida",
        whatsappRemoved: "WhatsApp removido",
        notDefined: "NÃ£o definido",
        noSchedule: "Sem agendamento",
        notCompleted: "NÃ£o concluÃ­da",
        loading: "Carregando...",
        noMessagesFound: "Nenhuma mensagem encontrada",
        enabled: "Habilitada",
        disabled: "Desabilitada",
        stopCampaign: "Parar Campanha",
        restartCampaign: "Reiniciar Campanha",
        stopRecurrence: "Interromper RecorrÃªncia",
        stopRecurrenceMessage: "Tem certeza que deseja interromper a recorrÃªncia desta campanha? A campanha atual continuarÃ¡ sendo executada, mas nÃ£o haverÃ£o mais execuÃ§Ãµes futuras.",
        report: "RelatÃ³rio",
        edit: "Editar",
        delete: "Excluir",
      },
      campaignReport: {
        title: "RelatÃ³rio de",
        inactive: "Inativa",
        scheduled: "Programada",
        process: "Em Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campanha",
        validContacts: "Contatos VÃ¡lidos",
        confirmationsRequested: "ConfirmaÃ§Ãµes Solicitadas",
        confirmations: "ConfirmaÃ§Ãµes",
        deliver: "Entregues",
        connection: "ConexÃ£o",
        contactLists: "Lista de Contatos",
        schedule: "Agendamento",
        conclusion: "ConclusÃ£o",
        fetchError: "Erro ao buscar dados do relatÃ³rio",
        backButton: "Voltar",
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "AÃ§Ãµes",
        },
        dialog: {
          edit: "EdiÃ§Ã£o de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas VisualizaÃ§Ã£o",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "MÃ©dia",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta aÃ§Ã£o nÃ£o pode ser revertida.",
        },
        toasts: {
          success: "OperaÃ§Ã£o realizada com sucesso",
          deleted: "Registro excluÃ­do",
        },
      },
      campaignsConfig: {
        title: "ConfiguraÃ§Ãµes de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudaÃ§Ã£o",
          orderQueue: "OrdenaÃ§Ã£o da fila (bot)",
          actions: "AÃ§Ãµes",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila exclu[ida com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "VocÃª tem certeza? Essa aÃ§Ã£o nÃ£o pode ser revertida! Os atendimentos dessa fila continuarÃ£o existindo, mas nÃ£o terÃ£o mais nenhuma fila atribuÃ­da.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      reports: {
        title: "RelatÃ³rios de Atendimentos",
        startDate: "Data Inicial",
        endDate: "Data final",
        table: {
          id: "Ticket",
          user: "UsuÃ¡rio",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "ConexÃ£o",
          queue: "Fila",
          actions: "AÃ§Ãµes",
          lastMessage: "Ãšlt. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
        },
        searchPlaceholder: "Pesquisar...",
      },
      queueIntegration: {
        title: "IntegraÃ§Ãµes",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualizaÃ§Ã£o",
          actions: "AÃ§Ãµes",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        form: {
          allowFlowbuilder: "Permitir FlowBuilder em paralelo",
          jsonContent: "ConteÃºdo JSON"
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "VocÃª tem certeza? Essa aÃ§Ã£o nÃ£o pode ser revertida! e serÃ¡ removida das filas e conexÃµes vinculadas",
        },
      },
      users: {
        title: "UsuÃ¡rios",
        table: {
          status: "Status",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "AÃ§Ãµes",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuÃ¡rio",
        },
        toasts: {
          deleted: "UsuÃ¡rio excluÃ­do com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuÃ¡rio serÃ£o perdidos. Os atendimento abertos deste usuÃ¡rio serÃ£o movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "ConexÃµes",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "AÃ§Ãµes",
          money: "R$",
          yes: "Sim",
          no: "NÃ£o",
          document: "CNPJ/CPF",
          recurrence: "RecorrÃªncia",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "UsuÃ¡rio",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluÃ­do com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serÃ£o perdidos. Os tickets abertos deste usuÃ¡rio serÃ£o movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "UsuÃ¡rios",
          connections: "ConexÃµes",
          queues: "Filas",
          amount: "Valor",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          trial: "Trial",
          trialDays: "Dias de Trial",
          public: "PÃºblico",
          enabled: "Habilitado",
          disabled: "Desabilitado",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "NÃ£o",
          money: "USD $",
        },
        confirmationModal: {
          deleteTitle: "ExclusÃ£o de Registro",
          deleteMessage: "Deseja realmente excluir esse registro?",
        },
        toasts: {
          loadingError: "NÃ£o foi possÃ­vel carregar a lista de registros",
          success: "OperaÃ§Ã£o realizada com sucesso!",
          error: "NÃ£o foi possÃ­vel realizar a operaÃ§Ã£o. Verifique se jÃ¡ existe um plano com o mesmo nome ou se os campos foram preenchidos corretamente",
        },
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "CÃ³digo do Video",
          description: "DescriÃ§Ã£o",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
      },
      schedules: {
        title: "Agendamentos",
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "MÃªs",
        previous: "Anterior",
        next: "PrÃ³ximo",
        yesterday: "Ontem",
        tomorrow: "AmanhÃ£",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "NÃ£o hÃ¡ agendamentos no perÃ­odo.",
        confirmationModal: {
          deleteTitle: "VocÃª tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta aÃ§Ã£o nÃ£o pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "AÃ§Ãµes",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluÃ­do com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADICIONAR COLUNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "VocÃª tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta aÃ§Ã£o nÃ£o pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "AÃ§Ãµes",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluÃ­do com sucesso.",
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        backToKanban: "VOLTAR PARA O KANBAN",

        confirmationModal: {
          deleteTitle: "VocÃª tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta aÃ§Ã£o nÃ£o pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "AÃ§Ãµes",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane excluÃ­da com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "AÃ§Ã£o",
        },
        toasts: {
          deleted: "Lista excluÃ­da com sucesso!",
          deletedAll: "Todas as listas foram excluÃ­das com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "ConfiguraÃ§Ãµes salvas com sucesso.",
        title: "ConfiguraÃ§Ãµes",
        tabs: {
          options: "OpÃ§Ãµes",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
          schedules: "HorÃ¡rios",
          whitelabel: "PersonalizaÃ§Ã£o",
          finalization: "FinalizaÃ§Ã£o do Atendimento"
        },
        settings: {
          userCreation: {
            name: "CriaÃ§Ã£o de usuÃ¡rio",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "OpÃ§Ãµes",
            schedules: "HorÃ¡rios",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            open: "Aberto",
            pending: "Pendente",
            creationCompanyUser: "CriaÃ§Ã£o de Company/UsuÃ¡rio",
            evaluations: "AvaliaÃ§Ãµes",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por ConexÃ£o",
            sendGreetingAccepted: "Enviar saudaÃ§Ã£o ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferÃªncia de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatÃ³rio",
            buttons: "BotÃµes",
            acceptCallWhatsapp: "Informar que nÃ£o aceita ligaÃ§Ã£o no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudaÃ§Ã£o quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posiÃ§Ã£o da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            transferredTicketStatus:
              "Status do ticket ao transferir com usuÃ¡rio",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificaÃ§Ã£o para tickets pendentes",
            copyContactPrefixSection: "Configuracao de sigla para copia de contatos",

            copyContactPrefix: "Sigla para CÃ³pia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posiÃ§Ã£o na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que nÃ£o aceita ligaÃ§Ãµes",
            greetingAcceptedMessage: "Mensagem de SaudaÃ§Ã£o ao aceitar ticket",
            transferMessage:
              "Mensagem de transferÃªncia - ${queue.name} = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da polÃ­tica de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar nÃºmero telefone para usuÃ¡rios",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "AtribuÃ­do Ã :",
          dialogRatingTitle:
            "Deseja deixar uma avaliaÃ§Ã£o de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar AvaliaÃ§Ã£o",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliaÃ§Ã£o",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecÃ§Ã£o",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar AvaliaÃ§Ã£o",
            enableIntegration: "Habilitar integraÃ§Ã£o",
            disableIntegration: "Desabilitar integraÃ§Ã£o",
            logTicket: "Logs do Ticket",
            requiredTag: "VocÃª deve atribuir uma tag antes de fechar o ticket.",
            greetingAcceptedMessage:
              "VocÃª deve configurar uma mensagem de saudaÃ§Ã£o ao aceitar o ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rÃ¡pidas",
        placeholderOpen:
          "Digite uma mensagem ou aperte / para respostas rÃ¡pidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informaÃ§Ãµes",
      },
      messageVariablesPicker: {
        label: "VariavÃ©is disponÃ­veis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "SaudaÃ§Ã£o",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "NÂº do Chamado",
          queue: "Setor",
          connection: "ConexÃ£o",
          scheduledDate: "Data do Agendamento",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "ObservaÃ§Ãµes do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar Ã¡udios do contato?",
        appointmentsModal: {
          title: "ObservaÃ§Ãµes do Ticket",
          textarea: "ObservaÃ§Ã£o",
          placeholder: "Insira aqui a informaÃ§Ã£o que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "AtenÃ§Ã£o! Todas as mensagens relacionadas ao ticket serÃ£o perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          triggerFlow: "Disparar Fluxo",
        },
        type: {
          imageVideo: "Fotos e vÃ­deos",
          cam: "CÃ¢mera",
          contact: "Contato",
          meet: "VÃ­deo chamada",
          template: "Template Meta",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        talkTo: "Conversar Com",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta aÃ§Ã£o nÃ£o pode ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "UsuÃ¡rios",
          connections: "ConexÃµes",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "AÃ§Ã£o",
        },
      },
      financial: {
        title: "Faturas",
        attention: "AtenÃ§Ã£o:",
        expiredMessage: "Sua assinatura estÃ¡ vencida. Entre em contacto com o suporte para regularizar sua situaÃ§Ã£o.",
        table: {
          details: "Detalhes",
          users: "UsuÃ¡rios",
          connections: "ConexÃµes",
          queues: "Filas",
          value: "Valor",
          dueDate: "Data Venc.",
          status: "Status",
          actions: "AÃ§Ã£o",
        },
        status: {
          paid: "Pago",
          expired: "Vencido",
          open: "Em Aberto",
        },
        buttons: {
          pay: "PAGAR",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrÃ£o.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrÃ£o encontrado. Verifique a pÃ¡gina de conexÃµes.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessÃ£o do WhatsApp nÃ£o foi inicializada. Verifique a pÃ¡gina de conexÃµes.",
        ERR_WAPP_CHECK_CONTACT:
          "NÃ£o foi possÃ­vel verificar o contato do WhatsApp. Verifique a pÃ¡gina de conexÃµes",
        ERR_WAPP_INVALID_CONTACT: "Este nÃ£o Ã© um nÃºmero de Whatsapp vÃ¡lido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "NÃ£o foi possÃ­vel baixar mÃ­dia do WhatsApp. Verifique a pÃ¡gina de conexÃµes.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticaÃ§Ã£o. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a pÃ¡gina de conexÃµes.",
        ERR_DELETE_WAPP_MSG: "NÃ£o foi possÃ­vel excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "JÃ¡ existe um tÃ­quete aberto para este contato.",
        ERR_SESSION_EXPIRED: "SessÃ£o expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criaÃ§Ã£o do usuÃ¡rio foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "VocÃª nÃ£o tem permissÃ£o para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "JÃ¡ existe um contato com este nÃºmero.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuraÃ§Ã£o encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tÃ­quete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuÃ¡rio encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tÃ­quete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor jÃ¡ estÃ¡ em uso, escolha outra.",
        ERR_CAMPAIGN_CONFIRMATION_MESSAGE_REQUIRED:
          "Informe pelo menos uma mensagem de confirmaÃ§Ã£o quando a confirmaÃ§Ã£o estiver ativada.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudaÃ§Ã£o Ã© obrigatÃ³rio quando hÃ¡ mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do HorÃ¡rio de Expediente!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "MÃ©todo:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensagem"',
        fieldUserId: '"userId": ID do usuÃ¡rio ou ""',
        fieldQueueId: '"queueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
        fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "RecorrÃªncia",
        description:
          "VocÃª pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma Ãºnica vez, nÃ£o altere nada nesta seÃ§Ã£o.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias nÃ£o Ãºteis",
        sendOneBusinessDayBefore: "Enviar um dia Ãºtil antes",
        sendOneBusinessDayLater: "Enviar um dia Ãºtil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Painel de Atendimentos",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atendimentos:",
        pending: "Pendentes",
        noqueue: "SEM FILA",
      },
      campaignsPhrase: {
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nome",
        status: "Status",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: "Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
        selectAConnection: " Selecione uma ConexÃ£o",
        chooseAStream: " Escolha um fluxo",
        status: " Status",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Salvar Campanha",
        active: "Ativo",
        disabled: "Desativado",
        noConnection: "Nenhuma conexao",
        nameNotDefined: "Nome nao definido",
        toastDeleted: "Campanha excluida com sucesso",
        emptyTitle: "Nenhuma campanha encontrada",
        emptyHint:
          'Clique em "Nova Campanha" para criar sua primeira campanha de fluxo',
      },
      whatsappModalRel: {
        form: {
          isOficial: "RelatÃ³rio do Atendimento",
          ticketId: "ID do Ticket",
          client: "Cliente",
          number: "NÃºmero",
          agent: "Atendente",
          date: "Data",
          lastMessage: "Ãšlt. Mensagem",
          lastMessageAt: "Data/Hora Ãšlt. Msg",
          groupTicketsReports: {
            fullReport: "O relatÃ³rio completo foi anexado acima",
            resolveAndTriggerIntegration: "Resolver e Disparar IntegraÃ§Ã£o",
            elementNotFoundForExport: "Elemento nÃ£o encontrado para exportar.",
            reportFilename: "relatÃ³rio_atendimento",
          },
        },
      },
      chatList: {
        noMessages: "Nenhuma mensagem",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Criar novo chat",
        searchUser: "Procurar usuÃ¡rio...",
        noUserFound: "Nenhum usuÃ¡rio encontrado",
        noUserAvailable: "Nenhum usuÃ¡rio disponÃ­vel",
        cancel: "Cancelar",
        details: "Detalhes",
        deleteChat: "Excluir Conversa",
        deleteChatConfirm: "Esta aÃ§Ã£o nÃ£o pode ser revertida, confirmar?",
        detailsTitle: "Detalhes",
        edit: "Editar",
        delete: "Excluir",
        now: "agora",
        minutesAgo: "{{count}}m atrÃ¡s",
        hoursAgo: "{{count}}h atrÃ¡s",
      },
      chatMessages: {
        deleted: "Esta mensagem foi apagada",
        deletedAdmin: "Mensagem apagada - visÃ­vel apenas para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        cancel: "Cancelar",
        deleteMessage: "Deletar Mensagem",
        deleteMessageConfirm: "Tem certeza que deseja deletar esta mensagem?",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        doubleClickToReply: "Clique duas vezes para responder",
        edited: "(editada)",
        forwarded: "(encaminhada)",
        typeMessage: "Digite uma mensagem...",
        send: "Enviar",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir atÃ© a mensagem original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar ExclusÃ£o",
        confirm: "Confirmar",
        deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        forward: "Encaminhar",
        noChats: "Nenhum chat disponÃ­vel",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Novo",
        messages: "Mensagens",
        search: "Buscar...",
        noChats: "Nenhum chat encontrado",
        noGroups: "Nenhum grupo encontrado",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        error: "Erro ao carregar dados",
        addGroupPhoto: "Adicionar Foto do Grupo",
        changeGroupPhoto: "Alterar Foto do Grupo",
        groupName: "Nome do Grupo",
        groupDescription: "DescriÃ§Ã£o do Grupo",
        save: "Salvar",
        cancel: "Cancelar",
        createGroup: "Criar Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Deletar Grupo",
        deleteGroupConfirm: "Tem certeza que deseja deletar este grupo?",
        edit: "Editar",
        delete: "Excluir",
        details: "Detalhes",
        groupDetails: "Detalhes do Grupo",
        title: "TÃ­tulo",
        description: "DescriÃ§Ã£o",
        modal: {
          title: "Criar grupo",
          name: "Nome do grupo",
          description: "DescriÃ§Ã£o do grupo",
          create: "Criar",
          cancel: "Cancelar",
          save: "Salvar",
          edit: "Editar",
        },
        modal: {
          title: "Criar Grupo",
          editTitle: "Editar Grupo",
          save: "Salvar",
          cancel: "Cancelar",
        },
      },
      flowBuilder: {
        title: "Editor de Fluxos",
        addNodes: "Adicionar NÃ³s",
        noConditions: "Sem condiÃ§Ãµes configuradas",
        startInfo: "InÃ­cio do fluxo",
        categories: {
          basics: "BÃ¡sicos",
          content: "ConteÃºdo",
          interaction: "InteraÃ§Ã£o",
          logic: "LÃ³gica",
          system: "Sistema",
          integrations: "IntegraÃ§Ãµes"
        },
        nodes: {
          start: { name: "InÃ­cio", desc: "Ponto inicial do fluxo" },
          content: { name: "ConteÃºdo", desc: "Enviar texto, imagem, Ã¡udio ou vÃ­deo" },
          text: { name: "Texto", desc: "Mensagem de texto simples" },
          img: { name: "Imagem", desc: "Enviar uma imagem" },
          audio: { name: "Ãudio", desc: "Enviar um Ã¡udio" },
          video: { name: "VÃ­deo", desc: "Enviar um vÃ­deo" },
          document: { name: "Documento", desc: "Enviar um arquivo/documento" },
          menu: { name: "Menu", desc: "Menu de opÃ§Ãµes para o usuÃ¡rio" },
          input: { name: "Input", desc: "Coletar entrada do usuÃ¡rio" },
          interval: { name: "Intervalo", desc: "Pausar execuÃ§Ã£o por tempo" },
          randomizer: { name: "Randomizador", desc: "Escolha aleatÃ³ria de caminhos" },
          condition: { name: "CondiÃ§Ã£o", desc: "RamificaÃ§Ã£o baseada em condiÃ§Ãµes" },
          router: { name: "Router", desc: "MÃºltiplas ramificaÃ§Ãµes lÃ³gicas" },
          queues: { name: "Filas", desc: "Gerenciar filas de atendimento" },
          tags: { name: "Tags", desc: "Adicionar tags ao contato" },
          removeTag: { name: "Remover Tag", desc: "Remover tags do contato" },
          switchFlow: { name: "Trocar Flow", desc: "Direcionar para outro fluxo" },
          attendant: { name: "Atendente", desc: "Transferir para atendente" },
          kanban: { name: "Kanban", desc: "Mover para Kanban" },
          closeTicket: { name: "Fechar Ticket", desc: "Encerra o atendimento atual" },
          followup: { name: "Followup", desc: "Agendar sequÃªncia de followup" },
          advancedPause: { name: "Pausa Inteligente", desc: "Pausa com mÃºltiplas saÃ­das" },
          httpRequest: { name: "HTTP Request", desc: "RequisiÃ§Ã£o HTTP externa" },
          variable: { name: "VariÃ¡vel", desc: "Definir variÃ¡veis globais" },
          gemini: { name: "Gemini", desc: "IntegraÃ§Ã£o com Gemini" },
          openai: { name: "OpenAI", desc: "IntegraÃ§Ã£o com OpenAI" },
          deepseek: { name: "DeepSeek", desc: "IntegraÃ§Ã£o DeepSeek AI" }
        },
        validation: {
          required: "ObrigatÃ³rio"
        },
        deepseekModal: {
          title: "Configurar DeepSeek",
          basicSettings: "ConfiguraÃ§Ã£o bÃ¡sica",
          addTitle: "Adicionar DeepSeek ao fluxo",
          editTitle: "Editar DeepSeek do fluxo",
          assistantName: "Nome do Assistente",
          apiKey: "API Key DeepSeek",
          model: "Modelo DeepSeek",
          systemPrompt: "Prompt do Sistema",
          promptPlaceholder: "Descreva como a IA deve se comportar, que informaÃ§Ãµes deve coletar e como deve responder...",
          searchVariable: "Buscar variÃ¡vel...",
          temperature: "Temperatura",
          temperatureHelp: "0 = conservador, 2 = criativo",
          maxTokens: "Max Tokens",
          maxTokensHelp: "Tamanho mÃ¡ximo da resposta",
          maxMessages: "Max Mensagens",
          maxMessagesHelp: "HistÃ³rico de contexto",
          flowBehavior: "Comportamento do Fluxo",
          flowBehaviorTooltip: "Configure como o DeepSeek deve se comportar no fluxo",
          operationMode: "Modo de Funcionamento",
          permanent: "Permanente",
          permanentDesc: "Encerrar o fluxo aqui",
          permanentHelp: "O usuÃ¡rio conversa com a IA atÃ© pedir transferÃªncia ou encerrar.",
          temporary: "TemporÃ¡rio",
          temporaryDesc: "Voltar ao fluxo depois",
          temporaryHelp: "A IA executa uma tarefa e depois retorna ao fluxo normal.",
          maxInteractions: "InteraÃ§Ãµes mÃ¡ximas",
          maxInteractionsHelp: "MÃ¡ximo de mensagens antes de voltar ao fluxo (0 = ilimitado).",
          completionTimeout: "Tempo limite (minutos)",
          completionTimeoutHelp: "Tempo limite antes de voltar ao fluxo (0 = sem limite).",
          continueKeywords: "Palavras-chave para continuar",
          keywordPlaceholder: "Digite uma palavra-chave",
          addKeyword: "Adicionar",
          continueKeywordsHelp: "Quando o usuÃ¡rio enviar uma dessas palavras, o fluxo continuarÃ¡ automaticamente.",
          objective: "Objetivo",
          objectivePlaceholder: "Descreva o objetivo da conversa",
          objectiveHelp: "Descreva o que a IA deve completar (ex.: â€œcoletar nome, email e telefoneâ€).",
          autoCompleteOnObjective: "Auto completar com objetivo",
          autoCompleteOnObjectiveHelp: "A IA avaliarÃ¡ se completou o objetivo e retornarÃ¡ ao fluxo.",
          skipResponseTitle: "Modo classificador",
          skipResponseSubtitle: "NÃ£o responder ao cliente",
          skipResponseHelp: "A IA analisa a mensagem mas nÃ£o envia resposta. Ãštil para roteamento automÃ¡tico com um Router depois.",
          skipResponse: "Pular resposta",
          temporarySettingsTitle: "ConfiguraÃ§Ã£o do modo temporÃ¡rio",
          temporarySettingsDesc: "Defina quando a IA deve parar e retornar ao fluxo.",
          queueId: "ID da fila (transferÃªncia)",
          queueIdHelp: "ID da fila para transferir se o usuÃ¡rio pedir atendente (0 = nÃ£o transferir).",
          variables: "VariÃ¡veis disponÃ­veis",
          variablesDesc: "Use estas variÃ¡veis nos seus prompts",
          save: "Adicionar",
          update: "Salvar",
          cancel: "Cancelar"
        },
        deepseek: {
          validation: {
            tooShort: "Muito curto!",
            tooLong: "Muito longo!"
          }
        },
        routerNode: {
          title: "Router LÃ³gico",
          description: "Ã‰ um seletor mÃºltiplo. VocÃª pode criar vÃ¡rios caminhos (ex: 'Vendas', 'PreÃ§os') em um Ãºnico nÃ³.",
          howItWorks: "1. O bot revisa a CondiÃ§Ã£o 1.\n2. Se for verdade, segue esse caminho.\n3. Se nÃ£o, revisa a CondiÃ§Ã£o 2...\n4. Se NADA coincidir, usa o caminho vermelho (PadrÃ£o).",
          defaultPath: "PadrÃ£o (Falso)",
          defaultDesc: "Se nenhuma condiÃ§Ã£o coincidir",
          addCondition: "Duplo clique para gerenciar",
          condition: "CondiÃ§Ã£o"
        },
        conditionNode: {
          title: "CondiÃ§Ã£o LÃ³gica",
          howToUse: "1. Selecione uma variÃ¡vel (ex: ultimaMensagem ou aiResponse).\n2. Escolha um operador (ex: contÃ©m ou igual).\n3. Defina o valor esperado.\n\nSe a regra for cumprida, o fluxo seguirÃ¡ pelo caminho Verde.\nSi nÃ£o, pelo caminho Vermelho.",
          true: "VERDADEIRO",
          false: "FALSO",
          value1: "Valor 1",
          value2: "Valor 2",
          operators: {
            equals: "Igual a",
            notEquals: "Diferente de",
            contains: "ContÃ©m",
            startsWith: "ComeÃ§a com",
            endsWith: "Termina com",
            greaterThan: "Maior que",
            lessThan: "Menor que",
            greaterOrEqual: "Maior ou igual a",
            lessOrEqual: "Menor ou igual a",
            isEmpty: "EstÃ¡ vazio",
            isNotEmpty: "NÃ£o estÃ¡ vazio",
          }
        },
        followup: {
          configure: "Configurar FollowUp",
          description: "Escolha qual sequÃªncia de FollowUp (Floup) serÃ¡ disparada quando o fluxo chegar aqui.",
          select: "Selecionar FollowUp",
          notConfigured: "NÃ£o configurado",
        },
        active: "Ativo",
        inactive: "Inativo",
        flowDeleted: "Fluxo excluÃ­do com sucesso",
        flowDuplicated: "Fluxo duplicado com sucesso",
        selectZipFile: "Por favor, selecione um arquivo ZIP (.zip)",
        searchFlows: "Buscar fluxos...",
        newFlow: "Novo Fluxo",
        createFlow: "Criar fluxo",
        confirmDelete: "Excluir fluxo",
        deleteWarning: "Esta aÃ§Ã£o nÃ£o pode ser desfeita. Todas as integraÃ§Ãµes relacionadas serÃ£o perdidas.",
        confirmDuplicate: "Duplicar fluxo",
        duplicateInfo: "Uma cÃ³pia do fluxo serÃ¡ criada para que vocÃª possa editÃ¡-la."
      },
      whitelabel: {
        primaryColorLight: "Cor PrimÃ¡ria (Tema Claro)",
        primaryColorDark: "Cor PrimÃ¡ria (Tema Escuro)",
        appName: "Nome da AplicaÃ§Ã£o",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        preview: "Visualizar",
        delete: "Excluir",
        upload: "Enviar",
        availableLanguages: "Idiomas DisponÃ­veis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",
        successMessage: "OperaÃ§Ã£o atualizada com sucesso",
        loadingSettings: "Carregando configuraÃ§Ãµes...",

        sections: {
          general: "ConfiguraÃ§Ãµes Gerais",
          generalDescription: "Configure o nome e informaÃ§Ãµes bÃ¡sicas da aplicaÃ§Ã£o",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primÃ¡rias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicaÃ§Ã£o",
          languages: "Idiomas DisponÃ­veis",
          languagesDescription: "Selecione quais idiomas estarÃ£o disponÃ­veis no sistema"
        },
        colorPicker: {
          title: "Escolha uma cor",
          cancel: "Cancelar",
          ok: "OK"
        }
      },
    },
    kanbanAutomation: {
      title: "AutomatizaÃ§Ãµes Kanban",
      miniManual: "Mini manual",
      hide: "Ocultar",
      show: "Mostrar",
      add: "Adicionar",
      close: "Fechar",
      refresh: "Atualizar",
      loadingExecutions: "Carregando execuÃ§Ãµes...",
      viewExecutions: "Ver execuÃ§Ãµes",
      newRule: "Nova regra",
      save: "Salvar",
      yes: "Sim",
      no: "NÃ£o",
      edit: "Editar",
      delete: "Excluir",
      form: {
        name: "Nome",
        event: "Evento",
        stage: "Etapa",
        anyStage: "Qualquer etapa",
        description: "DescriÃ§Ã£o",
        delayHours: "Horas (delay)",
        specificTime: "Hora especÃ­fica",
        hour: "Hora",
        minute: "Minuto",
        active: "Ativa",
        once: "Uma vez",
        value: "Valor",
        productPlaceholder: "Ex: Curso Premium"
      },
      manual: {
        missingTranslation: "NÃ£o hÃ¡ mini manual traduzido para este idioma. Troque o idioma para Espanhol/PortuguÃªs/English.",
        item1: "1. <strong>Nome</strong>: use um nome claro. Ex: <strong>Produto X - follow up</strong>.",
        item2: "2. <strong>Evento</strong>: quando dispara. <strong>Ao entrar na etapa</strong>: assim que o ticket chega. <strong>Depois de X horas na etapa</strong>: espera dentro da coluna. <strong>Depois de X horas desde a Ãºltima conversa</strong>: espera silÃªncio (reinicia se o cliente escreve). <strong>Em uma hora especÃ­fica</strong>: dispara no horÃ¡rio se continuar na etapa.",
        item3: "3. <strong>Etapa</strong>: escolha a coluna. Vazio = qualquer etapa.",
        item4: "4. <strong>Horas</strong>: o nÃºmero que substitui â€œXâ€. Ex: <strong>2</strong> = 2h apÃ³s entrar na etapa; <strong>6</strong> = 6h de silÃªncio desde a Ãºltima conversa.",
        item5: "5. <strong>Hora especÃ­fica</strong>: sÃ³ para o evento por horÃ¡rio. Ex: <strong>18:30</strong>.",
        item6: "6. <strong>Uma vez</strong>: se ligado, a regra nÃ£o roda vÃ¡rias vezes no mesmo ticket.",
        item7: "7. <strong>CondiÃ§Ãµes</strong>: para filtrar.",
        item7a: "- <strong>Produto + Igual a + Curso Premium</strong>: sÃ³ esse produto.",
        item7b: "- <strong>Tag do ticket + Tem + produto-premium</strong>: sÃ³ se o ticket tiver essa tag.",
        item7c: "- <strong>Campo custom do contato</strong>: use <strong>Campo</strong> com o nome exato.",
        item7d: "- <strong>Data inÃ­cio do ticket + Maior ou igual + 2026-03-01</strong>: tickets desde essa data.",
        item7e: "- <strong>Data da Ãºltima conversa + Antes de + 2026-03-10</strong>: detecta inatividade.",
        item8: "8. <strong>AÃ§Ãµes</strong>: disparar FlowBuilder, adicionar/remover tags ou mover etapa.",
        item8a: "8.1 <strong>Tag</strong> adiciona/remove tags normais.",
        item8b: "8.2 <strong>Payload</strong> Ã© avanÃ§ado; deixe vazio no uso normal.",
        item9: "9. <strong>Teste recomendado</strong>: crie regra com <strong>Ao entrar na etapa</strong>, sem condiÃ§Ãµes, aÃ§Ã£o <strong>Disparar FlowBuilder</strong>; mova um ticket e veja <strong>Ãšltimas execuÃ§Ãµes</strong>.",
        item10: "10. <strong>Por produto</strong>: uma condiÃ§Ã£o <strong>Produto = nome exato</strong> basta.",
        item11: "11. <strong>Importante</strong>: se o ticket jÃ¡ estava na etapa, prefira <strong>Hora especÃ­fica</strong> ou <strong>Depois de X horas na etapa</strong>.",
        item12: "12. <strong>Esvaziar uma etapa</strong>: regra com <strong>Hora especÃ­fica</strong>, sem condiÃ§Ãµes, aÃ§Ã£o <strong>Mover para etapa</strong> destino.",
        item13: "13. <strong>Follow-up por silÃªncio</strong>: evento <strong>Depois de X horas desde a Ãºltima conversa</strong> + horas + aÃ§Ã£o. Se o cliente escrever, reinicia.",
        item14: "14. <strong>HorÃ¡rio protegido</strong>: janela 08:00â€“21:00; fora dela, move para o prÃ³ximo horÃ¡rio vÃ¡lido.",
        item15: "15. <strong>EspaÃ§amento humano</strong>: se muitos tickets caem no mesmo horÃ¡rio, sÃ£o espaÃ§ados em 20s."
      },
      rules: {
        title: "Regras"
      },
      sections: {
        conditions: "CondiÃ§Ãµes",
        actions: "AÃ§Ãµes"
      },
      noConditions: "Sem condiÃ§Ãµes (aplica para todos).",
      table: {
        name: "Nome",
        event: "Evento",
        stage: "Etapa",
        active: "Ativa",
        actions: "AÃ§Ãµes",
        executionType: "Tipo de execuÃ§Ã£o",
        fireTime: "HorÃ¡rio de disparo"
      },
      modal: {
        executionsTitle: "ExecuÃ§Ãµes"
      },
      executions: {
        title: "Ãšltimas execuÃ§Ãµes",
        date: "Data",
        rule: "Regra",
        ticket: "Ticket",
        event: "Evento",
        status: "Status"
      }
    },
    wallets: {
      wallet: "Carteira"
    },
    callHistoricals: {
      cards: {
        total: "Total de ligaÃ§Ãµes",
        rejected: "LigaÃ§Ãµes rejeitadas",
        answered: "LigaÃ§Ãµes atendidas",
        finished: "LigaÃ§Ãµes finalizadas"
      },
      noRecords: "Nenhum registro encontrado",
      na: "N/A",
      direction: {
        incoming: "Ligacao recebida",
      },
      status: {
        ended: "Finalizada",
        active: "Ativa",
        ringing: "Tocando",
        busy: "Ocupado",
        noAnswer: "Nao atendida",
        rejected: "Rejeitada",
      },
    },
birthdaySettings: {
      title: "Aniversarios",
      loading: "Carregando configuracoes...",
      previewLabel: "Pre-visualizacao:",
      sections: {
        user: "Aniversarios de usuarios",
        contact: "Aniversarios de contatos",
        general: "Configuracoes gerais",
      },
      switches: {
        userEnabled: "Ativar aniversarios de usuarios",
        createAnnouncement:
          "Criar informativo interno para aniversarios de usuarios",
        contactEnabled:
          "Ativar envio automatico de mensagens de aniversario para contatos",
      },
      fields: {
        userMessage: "Mensagem de aniversario para usuarios",
        contactMessage: "Mensagem de aniversario para contatos",
        sendTime: "Hora de envio das mensagens",
        whatsappConnection: "Conexao WhatsApp para envio",
      },
      helpers: {
        userEnabled:
          "Quando ativado, um modal sera exibido e um informativo interno podera ser criado.",
        createAnnouncement:
          "Cria um informativo interno exibido para todos os usuarios da empresa.",
        userMessage: "Use {nome} para incluir o nome do usuario.",
        contactEnabled:
          "Envia automaticamente uma mensagem de aniversario via WhatsApp para contatos aniversariantes.",
        contactMessage:
          "Use {nome} para incluir o nome do contato e {idade} para a idade.",
        sendTime: "Horario em que as mensagens automaticas serao enviadas.",
        whatsappConnection:
          "Conexao WhatsApp que sera usada para enviar mensagens de aniversario.",
      },
      variables: {
        title: "Variaveis disponiveis nas mensagens:",
        tokens: {
          name: "{nome}",
          age: "{idade}",
        },
        labels: {
          name: "Nome da pessoa",
          age: "Idade da pessoa (somente contatos)",
        },
      },
      placeholders: {
        selectConnection: "Selecione uma conexao",
      },
      buttons: {
        save: "Salvar configuracoes",
        saving: "Salvando...",
        testMessage: "Testar mensagem",
      },
      prompts: {
        contactId: "Informe o ID de um contato para testar:",
      },
      toasts: {
        loadError: "Erro ao carregar configuracoes de aniversario",
        saveSuccess: "Configuracoes de aniversario salvas com sucesso!",
        saveError: "Erro ao salvar configuracoes",
        testSent: "Mensagem de teste enviada!",
        testError: "Erro ao enviar mensagem de teste",
      },
    },
    messagesApi: {
      title: "API externa - DocumentaÃ§Ã£o completa"
    },
  },
};

export { messages };


